import * as React from 'react';
import { StylesProps } from '../../../theme/jss-types';
import { singleConsignmentStyles } from '../single-consignment.styles';
import withStyles from 'react-jss';
import { ReduxStore } from 'reducers/redux.types';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import Cross from '../../../assets/cross';
import { omitBy, groupBy } from 'lodash';
import { formRules } from 'library/constants';
import {
    ExclamationCircleFilled,
    LeftOutlined,
    RightOutlined,
} from '@ant-design/icons';
import useIsMobile from 'hooks/useIsMobile';
import {
    ButtonNames,
    CreateActions,
    formFields,
    validationBuilderFieldMapping,
    SECTION_NAMES,
    fieldNameToKeysMapping,
    addressTypes,
    addressFields,
} from '../create-modal.constants';
import {
    ButtonAction,
} from '../create-consignment.types';
import { transformAddressFieldsForForm } from 'components/create-consignment/consignment-helper';
import {
    Button,
    Drawer,
    Form,
    Modal,
    Row,
    Steps,
    message,
    Divider,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { getFormFieldFromMapping, ifFieldExistsInMapping } from './components/generic-field-renderer';
import {
    createConsignment,
    createSingleCnWithPx,
    getContentList,
    getCurrencyCodes,
    getIncoTerms,
    getPudoHubs,
    getValidationData,
    fetchItemUnits,
    isProductCodeMasterActive,
    editSingleCnWithPx,
} from 'network/consignments.api';
import { Category, Commodity, PudoHubs } from 'library/Types';
import Loader from 'components/common/Loader';
import { getCountries, getUploadFileUrls, uploadImageToS3 } from 'network/common.api';
import { getLoadType } from 'network/pickup.api';
import {
    convertToAPIBodySaveSingle,
    internationalFields, isEmptyValue, nonDocumentFields, customFormSummaryStepNecessaryFields,
    getPiecesDetail,
    getInvoicesDetail,
}
    from './single-consignment-helper';
import sift from 'sift';
import { getPurchaseOrderDetails } from 'network/purchase.api';
import SummaryStep from '../single-consignment-steps/summary-step';
import { Master } from 'types/master-data-types';
import { getCurrentCustomer, getDimensionUnitFromVolumeUnit } from 'components/common/utils';
import { transformPayloadNew } from './single-cn-new-px';
import { uploadImagesToS3 } from '../../../library/file-upload-util';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { useState } from 'react';

const lodash = require('lodash');

const intKeys = [
    'length',
    'width',
    'height',
    'cod_amount',
    'cop_amount',
    'weight',
    'destination_details.latitude',
    'destination_details.longitude',
    'return_details.latitude',
    'return_details.longitude',
    'origin_details.latitude',
    'origin_details.longitude',
    'alternate_delivery_details_1.latitude',
    'alternate_delivery_details_1.longitude',
    'alternate_delivery_details_2.latitude',
    'alternate_delivery_details_2.longitude',
    'redirection_address.latitude',
    'redirection_address.longitude',
    'declared_value',
    'num_pieces',
    'freight_cost',
    'fob_value',
    'total_gst_paid_amount',
    'invoice_amount',
    'customs_value.amount',
];
const pieceLevelIntKeys = [
    'quantity',
    'weight',
    'length',
    'width',
    'height',
    'codAmount',
];
const invoiceLevelIntKeys = [
    'invoiceAmount',
    'ewbCreationTime',
    'ewbExpiryTime',
];

const ADDRESS_FIELDS = ['srcAddress', 'dstAddress'];

const normalizeAddressValue = (val: any) => (val === null || val === undefined || val === '' ? undefined : val);

const pickAddressComparableFields = (address: any) => {
    if (!address || typeof address !== 'object') return address;
    return addressFields.reduce((acc: any, key) => {
        acc[key] = normalizeAddressValue(address[key]);
        return acc;
    }, {});
};

const WHITELISTED_CONSIGNMENT_FIELDS = [
    'serviceTime',
    'reference_number',
    'pickupServiceTime',
    'weight',
    'volume',
    'height',
    'width',
    'length',
    'serviceType',
    'srcAddress',
    'dstAddress',
];

const WHITELISTED_PIECE_FIELD_PREFIXES = [
    'piece_weight_',
    'piece_length_',
    'piece_width_',
    'piece_height_',
    'piece_unit_',
    'piece_weightUnit_',
];

type DataInputType = Record<string, any>;
type ReferenceObjectType =Record<string, any>;

interface SingleConsignmentProps extends StylesProps<ReturnType<typeof singleConsignmentStyles>>,
    ReturnType<typeof mapStateToProps> {
    visible?: boolean;
    onClose: () => void;
    setSuccess: (data: any) => void;
    loadconsignments: () => void;
    editData?: any;
    formLayoutConfig: any;
    actionType?: any;
    shipmentPurposeList: any;
    subLayout: any;
    customFieldsList: any;
    pickup_schedule_creation: boolean;
    show_product_code_dropdown: boolean;
    allowChildLoginOnParent: boolean;
    softdataCreationUnifiedFlow: boolean;
    softdataActionTypeEnum: any;
    master: Master;
    enableServiceability: boolean;
    disableSlotSuggestion: boolean;
}

interface DocumentDetailsUploadPayload {
    type: string;
    url: string;
}

const SingleConsignment = (props: SingleConsignmentProps) => {
    const {
        classes,
        visible = true,
        onClose,
        editData,
        formLayoutConfig,
        mandatoryFieldNonDocIntl,
        mandatoryFieldShipmentCommercial,
        mandatoryPieceDetails,
        showRiskSurchargeType,
        loadconsignments,
        showInvoiceOptions,
        setSuccess,
        useCategory,
        actionType,
        shipmentPurposeList,
        subLayout,
        customFieldsList,
        pickup_schedule_creation,
        show_product_code_dropdown,
        allowChildLoginOnParent,
        softdataCreationUnifiedFlow,
        softdataActionTypeEnum,
        autoCalculateDetails,
        master,
        enableServiceability,
        validatePiecePurchaseOrder,
        useHubTimezoneForStorage,
        fieldsToDisableInEdit,
        disableSlotSuggestion,
    } = props;
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();

    const [form] = Form.useForm();

    const [closeConfirm, setCloseConfirm] = React.useState<boolean>(false);
    const [visited, setVisited] = React.useState<{[key: number]: boolean | undefined | null}>({});
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);
    const [creating, setCreating] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [childClients, setChildClients] = React.useState<any>([]);
    const [pudoHubs, setPudoHubs] = React.useState<PudoHubs[]>([]);
    const [contentList, setContentList] = React.useState<Commodity[]>([]); // old
    const [categoryList, setCategoryList] = React.useState<Category[]>([]); // new
    const [itemUnits, setItemUnits] = React.useState<any[]>([]);
    const [piecesData, setPiecesData] = React.useState<any[]>([]);
    const [invoicesData, setInvoicesData] = React.useState<any>([]);
    const [currencyList, setCurrencyList] = React.useState<any[]>([]);
    const [countryList, setCountryList] = React.useState<any[]>([]);
    const [manufacturingCountryList, setManufacturingCountryList] = React.useState<any[]>([]);
    const [incotermsList, setIncotermsList] = React.useState<any>([]);
    const [loadType, setLoadType] = React.useState<any>([]);
    const [validationData, setValidationData] = React.useState<any>([]);
    const [validationBuilderKeysMapping, setValidationBuilderKeysMapping] = React.useState<any>([]);
    const [formLayout, setFormLayout] = React.useState<any>(formLayoutConfig);
    const [creatingAddress, setCreatingAddress] = React.useState<boolean>(false);
    const [productCodeActive, setProductCodeActive] = React.useState<boolean>(false);
    const [productCodeLists, setProductCodeLists] = React.useState<any[]>([]);
    const [productHsCodeMapping, setProductHsCodeMapping] = React.useState<Record<number, Record<string, string>>>({});
    const [addressErrors, setAddressErrors] = React.useState<any>({});
    const [disabledFields, setDisabledFields] = React.useState<any>({});
    const [productCode, setProductCode] = React.useState<string>('');
    const [destinationHolidays, setDestinationHolidays] = React.useState<string[]>([]);
    const [destinationDeliveryDays, setDestinationDeliveryDays] = React.useState<string[]>([]);
    const [deliveryDateValue, setDeliveryDateValue] = useState<string>('');
    const [selectedService, setSelectedService] = React.useState<string | undefined>(undefined);
    const [formSnapshot, setFormSnapshot] = React.useState<any>(null);
    const [isSlotLocked, setIsSlotLocked] = React.useState<boolean>(false);
    const [previousSlotData, setPreviousSlotData] = React.useState<any>(null);
    const [currentSlotData, setCurrentSlotData] = React.useState<any>(null);
    const [destinationHubTimezone, setDestinationHubTimezone] = React.useState<string>('');
    const isWarningModalOpenRef = React.useRef<boolean>(false);
    // True while we trigger form.validateFields() programmatically (submit / tab change).
    // validateFields makes antd re-fire onFieldsChange, which must not pop the slot-refetch warning.
    const isProgrammaticValidationRef = React.useRef<boolean>(false);

    const {
        Length,
        Width,
        Height,
        Unit,
        Weight,
        WeightUnit,
        ItemUnitType,
        ContentTypes,
        ContentNameForOthers,
        Amount,
        Quantity,
        NumPieces,
        DeclaredValue,
        Description,
        RiskSurcharge,
        MEIS,
        PurchaseOrderNumber,
        Eccn,
        PieceProductCode,
        HsCode,
        IossCode,
        IsKit,
        ManufacturingCountry,
        ForwardReferenceNumber,
        ProductCategory,
        ProductFamily,
        BrandName,
        ConsignmentCategory,
        ItemType,
        ReferenceNumber,
        ProofImageList,
        SubAccount,
        ConsignmentReference,
        DeliveryDate,
        DeliveryDateAndTimeslot,
        DeliveryTimeSlot,
    } = formFields;

    const consignmentCategory = Form.useWatch(ConsignmentCategory.key, form);
    const courierType = Form.useWatch('courierType', form);
    const itemType = Form.useWatch(ItemType.key, form);

    const addCustomFieldsToValidationBuilderMapping = () => {
        const customFieldsKeys: string[] = customFieldsList?.map((item: any) => ({ [item.id]: item.id }));
        const customFieldsKeysObject = customFieldsKeys?.reduce((acc, obj: any) => ({ ...acc, ...obj }), {});
        setValidationBuilderKeysMapping({ ...validationBuilderFieldMapping, ...customFieldsKeysObject });
    };

    React.useEffect(() => {
        if (formLayoutConfig?.length) {
            let layout = formLayoutConfig;
            if (disableSlotSuggestion) {
                layout = lodash.cloneDeep(formLayoutConfig).map((page: any) => ({
                    ...page,
                    sections: page?.sections?.map((section: any) => {
                        if (!section?.fieldsList?.includes(DeliveryDateAndTimeslot.key)) {
                            return section;
                        }
                        const replacedFields: string[] = [];
                        section.fieldsList.forEach((field: string) => {
                            if (field === DeliveryDateAndTimeslot.key) {
                                replacedFields.push(DeliveryDate.key, DeliveryTimeSlot.key);
                            } else {
                                replacedFields.push(field);
                            }
                        });
                        return { ...section, fieldsList: replacedFields };
                    }),
                }));
            }
            setFormLayout([...layout, { prettyName: 'summary' }]);
        }
    }, [formLayoutConfig, disableSlotSuggestion]);

    React.useEffect(() => {
        setVisited({
            ...visited,
            [currentTabIndex]: true,
        });
        addCustomFieldsToValidationBuilderMapping();
    }, [currentTabIndex]);

    const loadValidationData = async () => {
        const result = await getValidationData('consignment_softdata_validation');
        setValidationData(result?.data?.validations || []);
    };

    const checkForPieceField = (layout: any) => {
        return layout?.some((section: any) => section?.sections?.some(
            (subSection: any) => subSection?.fieldsList?.includes('piece'),
        ));
    };

    const checkForInvoiceField = (layout: any) => {
        return layout?.some((section: any) => section?.sections?.some(
            (subSection: any) => subSection?.fieldsList?.includes('invoice'),
        ));
    };

    const isPieceEnabled = checkForPieceField(formLayout);
    const isInvoiceEnabled = checkForInvoiceField(formLayout);
    const isSlotSuggestionEnabled = formLayout?.some((layout: any) => layout.sections?.some(
        (section: any) => section.fieldsList?.includes(DeliveryDateAndTimeslot.key),
    ));
    const isCodFieldPresent = formLayout?.some((layout: any) => layout.sections?.some(
        (section: any) => section.fieldsList?.includes('isCOD'),
    ));

    const loadAccounts = async () => {
        const result = getCurrentCustomer(master?.children_list);
        setChildClients(result || []);
        const customer = result?.length ? result[0] : undefined;
        form.setFieldsValue({
            [formFields.SubAccount.key]: form.getFieldValue(formFields.SubAccount.key)
                || `${customer.customer_code}+${customer.customer_id}+${customer.customer_name}`,
        });
    };

    const loadPudoHubs = async () => {
        const response = await getPudoHubs();
        setPudoHubs(response?.data || []);
    };

    const loadContents = async () => {
        const response = await getContentList({
            isInternational: false,
            useCommodityCategory: useCategory,
        });
        if (useCategory) {
            setCategoryList(response?.data);
        } else {
            setContentList(response?.data);
        }
    };

    const loadItemUnits = async () => {
        setLoading(true);
        const response = await fetchItemUnits();
        if (response?.data?.length) {
            const data = response?.data || [];
            const itemUnitsToSet = data.map((entry:any) => {
                return {
                    label: entry?.name,
                    value: entry?.code,
                };
            });
            setItemUnits(itemUnitsToSet);
        }
        setLoading(false);
    };

    const checkProductCodeMasterActive = async () => {
        setLoading(true);
        const response = await isProductCodeMasterActive();
        if (response.isSuccess) {
            setProductCodeActive(response?.data?.is_product_code_master_active);
        }
        setLoading(false);
    };

    const loadCurrencyCodes = async () => {
        const response = await getCurrencyCodes();
        setCurrencyList(response?.data);
    };

    const loadCountries = async () => {
        const countriesResponse = await getCountries();
        if (countriesResponse.isSuccess) {
            setCountryList(countriesResponse.data.map((obj: any) => {
                return {
                    value: obj.country,
                    label: obj.country,
                };
            }));
            setManufacturingCountryList(
                countriesResponse?.data?.map((obj: any) => {
                    return {
                        value: obj?.country_code,
                        label: obj?.country,
                    };
                }).sort((a: any, b: any) => a?.label?.localeCompare(b?.label)),
            );
        }
    };

    const isDisabledNumPiece = () => {
        if (isPieceEnabled) {
            return true;
        }
        return (consignmentCategory === 'international' && autoCalculateDetails);
    };

    const fetchPoDetails = async (referenceNumber: string, index: number) => {
        const response = await getPurchaseOrderDetails({
            referenceNumber,
        });
        if (response.isSuccess) {
            const pieces = response.data?.pieces_detail || [];
            const activePieces = pieces?.filter((piece: any) => piece?.status === 'Open') || [];
            const mapping : Record<string, string> = {};
            activePieces?.forEach((piece: any) => {
                if (!mapping[piece?.product_code]) {
                    mapping[piece?.product_code] = piece?.hs_code;
                }
            });

            setProductHsCodeMapping((prevMapping: any) => ({
                ...(prevMapping || {}),
                [index]: mapping,
            }));

            const unique = Array.from(new Set(activePieces?.map((piece: any) => piece.product_code)));
            const newProductCodeLists = [...productCodeLists];
            newProductCodeLists[index] = unique;
            setProductCodeLists(newProductCodeLists);
        } else {
            message.error(response.errorMessage);
        }
    };

    const resetProductCode = (index: number) => {
        const newProductCodeLists = [...productCodeLists];
        newProductCodeLists[index] = [];
        setProductCodeLists(newProductCodeLists);
        form.setFieldsValue({
            [`pieceProductCode_${index}`]: undefined,
            [`hsCode_${index}`]: undefined,
        });
    };

    const placeholderNumPieces = () => {
        if (isPieceEnabled) {
            return ('1');
        }
        return t('num_pieces_label');
    };

    const loadIncoterms = async () => {
        const response = await getIncoTerms();
        if (!response.isSuccess) {
            message.error(response.errorMessage);
        } else {
            setIncotermsList(
                response?.data.map((incoTerm: any) => {
                    return {
                        label: incoTerm,
                        value: incoTerm,
                    };
                }),
            );
        }
    };

    const loadLoadTypeList = async () => {
        const response = await getLoadType();
        setLoadType(response?.data || []);
    };


    const transformDataForForm = (data: any) => {
        const transformedData = {
            ...data,
            consignmentCategory: data.is_international ? 'international' : 'domestic',
            retailTransactionType: data.is_retail_transaction ? 'retailTransactionTrue' : 'retailTransactionFalse',
            movementType: data.movement_type,
            referenceNumber: data.reference_number,
            customerReferenceNumber: data.customer_reference_number,
            cashonpickup: data.cop_amount || 0,
            typeOfDelivery: data.type_of_delivery === 'HOME_DELIVERY' ? 'HOME_DELIVERY' : 'PUDO',
            kiranaHubCode: data.kirana_hub_code,
            ewbNumber: data.ewb_number,
            ewbDate: data.ewb_date ? moment(data.ewb_date) : undefined,
            courierType: data.load_type === 'DOCUMENT' ? 'document' : 'non-document',
            declaredValue: data.declared_value,
            isRiskSurchargeApplicable: data.is_risk_surcharge_applicable ? 'true' : 'false',
            description: data.description,
            serviceType: data.service_type_id,
            pickupSchedule: data.pickup_date ? moment(data.pickup_date) : undefined,
            pickupServiceTime: data.pickup_service_time,
            length: data.length,
            width: data.width,
            height: data.height,
            weight: data.weight,
            weightUnit: data.weight_unit,
            unit: data.unit ?? getDimensionUnitFromVolumeUnit(data.input_volume_unit),
            quantity: data.quantity,
            deliveryDate: data.delivery_date ? moment(data.delivery_date) : undefined,
            pickupTime: (data.pickup_time_slot_start && data.pickup_time_slot_end) ? [
                moment(Number(data.pickup_time_slot_start)),
                moment(Number(data.pickup_time_slot_end)),
            ] : undefined,
            shipmentPurpose: data.load_type === 'NON-DOCUMENT' ? data.international_detail_shipment_purpose : null,
            shipmentPurposeDoc: data.load_type === 'DOCUMENT' ? data.international_detail_shipment_purpose : null,
            deliveryTerms: data.delivery_terms,
            deliveryInstruction: data.delivery_instruction,
            pickupInstruction: data.pickup_instruction,
            againstBondLut: data.against_bond_lut,
            ecomShipment: data.ecom_shipment ? 'true' : 'false',
            meis: data.meis ? 'true' : 'false',
            isBattery: data.is_battery ? 'true' : 'false',
            receiverVATNumber: data.receiver_vat_number,
            consigneeCompanyName: data.consignee_company_name,
            consignorCompanyName: data.consignor_company_name,
            originType: data.origin_type,
            destinationType: data.destination_type,
            consignorIECNumber: data.consignor_iec_number,
            consignorGSTINNumber: data.consignor_gstin_number,
            consignorPANNumber: data.consignor_pan_number,
            senderBankAccountNumber: data.sender_bank_account_number,
            senderBankADCode: data.sender_bank_ad_code,
            senderBankIFSCCode: data.sender_bank_ifsc_code,
            nefiFlag: data.nefi_flag ? 'true' : 'false',
            cpcCode: data.cpc_code,
            consignorKycDocType: data.consignor_kyc_doc_type,
            consignorKycDocNumber: data.consignor_kyc_doc_number,
            consignorKycFrontImage: data.consignor_kyc_front_image,
            consignorKycBackImage: data.consignor_kyc_back_image,
            isCOD: data.is_cod ? 'yes' : 'no',
            codAmount: data.is_cod ? data.cod_amount : undefined,
            codCollectionMode: data.is_cod ? data.cod_collection_mode : undefined,
            codFavorOf: data.is_cod ? data.cod_favor_of : undefined,
            ewayBillNumber: data.is_international ? data.eway_bill : undefined,
            invoiceType: data.invoice_type,
            invoiceDate: data.invoice_date ? moment(data.invoice_date) : undefined,
            invoiceNumber: data.invoice_number,
            incoTerms: data.inco_terms,
            fobValue: data.fob_value,
            fobValueCurrency: data.fob_value_currency,
            freightCost: data.freight_cost,
            freightCostCurrency: data.freight_cost_currency,
            totalGSTPaidAmount: data.total_gst_paid_amount,
            totalGSTPaidCurrency: data.total_gst_paid_currency,
            numberOfPieces: data.num_pieces,
            invoiceAmount: data.invoice_amount,
            purpose: data.purpose,
            consigneeCode: data.consignee_code,
            isCustomsDeclarable: data.is_customs_declarable ? 'true' : 'false',
            isCsbv: data.is_csbv ? 'true' : 'false',
            manufacturingCountry: data.manufacturing_country,
            prodName: data.prod_name,
            cessValue: data.cess_value,
            isStackable: data.is_stackable ? 'true' : 'false',
            cgst: data.cgst,
            igst: data.igst,
            sgst: data.sgst,
            taxDetailsRecieverGstin: data.tax_details_reciever_gstin,
            taxDetailsSenderGstin: data.tax_details_sender_gstin,
            forwardReferenceNumber: data.forward_reference_number,
            productCode: data.product_code,
            purchaseOrderNumber: data.purchase_order_number,
            deliveryTime: (data.delivery_time_slot_start && data.delivery_time_slot_end) ? [
                moment(Number(data.delivery_time_slot_start)),
                moment(Number(data.delivery_time_slot_end)),
            ] : undefined,
            commodityId: data.commodity_id,
            unlistedCommodityName: data.unlisted_commodity_name,
            reference_number: data.reference_number,
            resourceSlotLockId: data.resource_slot_lock_id,
            srcAddress: transformAddressFieldsForForm(data, 'sender'),
            dstAddress: transformAddressFieldsForForm(data, 'destination'),
            actionType: data.action_type,
        };

        const piecesArray = data?.pieces_detail;
        if (piecesArray && Array.isArray(piecesArray)) {
            setPiecesData(piecesArray);
            piecesArray.forEach((piece: any, index: number) => {
                transformedData[`piece_${ContentTypes.key}_${index}`] = piece.commodity_id;
                transformedData[`piece_${ItemUnitType.key}_${index}`] = piece.item_unit;
                transformedData[`piece_${Amount.key}_${index}`] = piece.cod_amount;
                transformedData[`piece_${Quantity.key}_${index}`] = piece.quantity;
                transformedData[`piece_${ContentNameForOthers.key}_${index}`] = piece.unlisted_commodity_name;
                transformedData[`piece_${ReferenceNumber.key}_${index}`] = piece.reference_number;
                transformedData[`piece_${NumPieces.key}_${index}`] = piece.item_quantity || piece.quantity;
                transformedData[`piece_${Weight.key}_${index}`] = piece.weight;
                transformedData[`piece_${WeightUnit.key}_${index}`] = piece.weight_unit || piece.weightUnit;
                transformedData[`piece_${Length.key}_${index}`] = piece.length;
                transformedData[`piece_${Width.key}_${index}`] = piece.width;
                transformedData[`piece_${Height.key}_${index}`] = piece.height;
                transformedData[`piece_${Unit.key}_${index}`] = piece.dimension_unit
                                                                || piece.dimensionUnit
                                                                || getDimensionUnitFromVolumeUnit(piece.volume_unit);
                transformedData[`piece_${DeclaredValue.key}_${index}`] = piece.declared_value;
                transformedData[`piece_${RiskSurcharge.key}_${index}`] = piece.risk_surcharge;
                transformedData[`piece_${Description.key}_${index}`] = piece.description;
                transformedData[`piece_${MEIS.key}_${index}`] = piece.meis;
                transformedData[`piece_${PurchaseOrderNumber.key}_${index}`] = piece.purchase_order_number;
                transformedData[`piece_${PieceProductCode.key}_${index}`] = piece.piece_product_code;
                transformedData[`piece_${Eccn.key}_${index}`] = piece?.additional_properties?.eccn;
                transformedData[`piece_${HsCode.key}_${index}`] = piece?.additional_properties?.hsn_code;
                transformedData[`piece_${IossCode.key}_${index}`] = piece?.additional_properties?.ioss_number;
                transformedData[`piece_${IsKit.key}_${index}`] = piece?.additional_properties?.is_kit;
                transformedData[`piece_${ManufacturingCountry.key}_${index}`] = piece.manufacturing_country;
                transformedData[`piece_${ForwardReferenceNumber.key}_${index}`] = piece.forward_reference_number;
                transformedData[`piece_${ProductCategory.key}_${index}`] = piece.product_category;
                transformedData[`piece_${ProductFamily.key}_${index}`] = piece.product_family;
                transformedData[`piece_${BrandName.key}_${index}`] = piece.brand_name;
            });
        }
        return transformedData;
    };

    const handleInitialDisabledFields = () => {
        const newDisabledFields: Record<string, boolean> = { ...disabledFields };
        newDisabledFields[ConsignmentReference.key] = true;
        newDisabledFields[SubAccount.key] = true;
        newDisabledFields[ReferenceNumber.key] = true;
        newDisabledFields[ForwardReferenceNumber.key] = true;
        if (editData && Array.isArray(fieldsToDisableInEdit)) {
            fieldsToDisableInEdit.forEach((fieldKey: string) => {
                if (fieldKey) {
                    newDisabledFields[fieldKey] = true;
                    if (fieldKey === DeliveryDateAndTimeslot.key && disableSlotSuggestion) {
                        newDisabledFields[DeliveryDate.key] = true;
                        newDisabledFields[DeliveryTimeSlot.key] = true;
                    }
                    if (fieldKey === 'dimensions') {
                        newDisabledFields[Length.key] = true;
                        newDisabledFields[Width.key] = true;
                        newDisabledFields[Height.key] = true;
                        newDisabledFields[Unit.key] = true;
                    }
                }
            });
        }
        setDisabledFields(newDisabledFields);
    };

    const initializeFormData = () => {
        const transformedData = transformDataForForm(editData);
        handleInitialDisabledFields();
        form.setFieldsValue(transformedData);

        if (editData?.resource_slot_lock_id) {
            setIsSlotLocked(true);
            setTimeout(() => {
                setFormSnapshot(transformedData);
            }, 0);
        }

        if (editData?.delivery_date && editData?.delivery_time_slot_start && editData?.delivery_time_slot_end) {
            const tz = editData?.destination_hub_timezone || '';
            let startTime;
            let endTime;
            let deliveryDateMoment;
            if (tz && useHubTimezoneForStorage) {
                startTime = momentTimezone(Number(editData.delivery_time_slot_start)).tz(tz);
                endTime = momentTimezone(Number(editData.delivery_time_slot_end)).tz(tz);
                if (editData.delivery_time_slot_start) {
                    deliveryDateMoment = momentTimezone(Number(editData.delivery_time_slot_start)).tz(tz).startOf('day');
                } else if (editData.delivery_date) {
                    deliveryDateMoment = momentTimezone(editData.delivery_date).tz(tz);
                }
                setDestinationHubTimezone(tz);
            } else {
                startTime = moment(Number(editData.delivery_time_slot_start));
                endTime = moment(Number(editData.delivery_time_slot_end));
            }
            const slotString = `${startTime.format('HH:mm:ss')} - ${endTime.format('HH:mm:ss')}`;
            const deliveryDateStr = deliveryDateMoment ? deliveryDateMoment.format('YYYY-MM-DD') : editData.delivery_date;

            setCurrentSlotData({
                deliveryDate: deliveryDateStr,
                timeSlot: [startTime, endTime],
                resourceSlotLockId: editData.resource_slot_lock_id,
                slot: slotString,
            });

            form.setFieldsValue({
                ...(deliveryDateMoment ? { [formFields.DeliveryDate.key]: deliveryDateMoment } : {}),
                [formFields.DeliveryTimeSlot.key]: [startTime, endTime],
            });

            setDeliveryDateValue(deliveryDateStr);
        }
    };

    const loadData = async () => {
        setLoading(true);
        await Promise.all([
            checkProductCodeMasterActive(),
            loadAccounts(),
            loadPudoHubs(),
            loadContents(),
            loadCurrencyCodes(),
            loadCountries(),
            loadIncoterms(),
            loadLoadTypeList(),
            loadValidationData(),
            loadItemUnits(),
            editData && initializeFormData(),
        ]);
        setLoading(false);
    };

    React.useEffect(() => {
        loadData();
    }, []);

    function flattenObject(obj: any, parentKey = '') {
        return Object.keys(obj).reduce((acc, key) => {
            const prefixedKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
                Object.assign(acc, flattenObject(obj[key], prefixedKey));
            } else {
                acc[prefixedKey] = obj[key];
            }
            return acc;
        }, {} as any);
    }

    function unflattenObject(flatObj: any) {
        const unflatten = (obj: any) => {
            const result = {};
            const objKeys = Object.keys(obj);
            objKeys.forEach((key) => {
                const keys = key.split('.');
                let nestedObj: any = result;
                for (let i = 0; i < keys.length - 1; i += 1) {
                    const nestedKey = keys[i];
                    if (!(nestedKey in nestedObj)) {
                        nestedObj[nestedKey] = {};
                    }
                    nestedObj = nestedObj[nestedKey];
                }
                nestedObj[keys[keys.length - 1]] = obj[key];
            });
            return result;
        };

        return unflatten(flatObj);
    }
    const replaceReferenceInObject = (obj: any, refObj: DataInputType): any => {
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        if (Array.isArray(obj)) {
            return obj.map((value) => {
                if (value && typeof value === 'object' && value.$reference) {
                    const path = value.$reference;
                    return lodash.get(refObj, path);
                }
                return replaceReferenceInObject(value, refObj);
            });
        }
        const result = { ...obj };
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (value && typeof value === 'object' && value.$reference) {
                const path = value.$reference;
                const valueToSet = lodash.get(refObj, path);
                result[key] = valueToSet;
            } else {
                result[key] = replaceReferenceInObject(value, refObj);
            }
        });
        return result;
    };

    const referenceReplacer = (referenceObject: ReferenceObjectType, dataInput: DataInputType): ReferenceObjectType => {
        const newRefObj = lodash.cloneDeep(referenceObject);
        const result = replaceReferenceInObject(newRefObj, dataInput);
        return result;
    };

    const getFilteredValidations = (validateAllFields: any) => {
        if (!formLayout) return true;
        const formLayoutDataToValidate = [];
        if (validateAllFields) {
            formLayoutDataToValidate.push(...formLayout);
        } else {
            formLayoutDataToValidate.push(formLayout[currentTabIndex]);
        }
        const fields = formLayoutDataToValidate.map(
            (layout: any) => layout?.sections?.map((section: any) => {
                const fieldsList = section?.fieldsList ?? [];
                return fieldsList.map((field: string) => {
                    if (subLayout[field]) {
                        return [...(subLayout[field] || [])];
                    }
                    return field;
                }).flat();
            }).flat(),
        ).flat() ?? [];
        if (fields.includes('dimensions')) {
            fields.push('length', 'width', 'height');
        }
        if (fields.includes('address')) {
            fields.push(...addressTypes);
        }
        // eslint-disable-next-line
        for (const addressType of addressTypes) {
            if (fields.includes(addressType)) {
                // eslint-disable-next-line
                for (const field of addressFields) {
                    fields.push(
                        `${addressType}.${field}`,
                    );
                }
            }
        }
        const mappedFields = Object.keys(validationBuilderKeysMapping).filter((key) => {
            return fields.some((field: string) => key === field);
        }).map((key: string) => validationBuilderKeysMapping[key]);
        const isPieceValidationsEnabled = checkForPieceField(formLayoutDataToValidate) || validateAllFields;
        const isInvoiceValidationsEnabled = checkForInvoiceField(formLayoutDataToValidate) || validateAllFields;
        return validationData?.filter((data_: any) => {
            const condition = data_.filter.what || {};
            if (data_?.extraKeys?.keyIdentifier === 'piece' && !isPieceValidationsEnabled) {
                return false;
            }
            if (data_?.extraKeys?.keyIdentifier === 'invoice' && !isInvoiceValidationsEnabled) {
                return false;
            }
            /* eslint-disable */
            for (const key of Object.keys(condition)) {
                if (key === '$or' || key === '$and') {
                    for (const subCondition of condition[key]) {
                    for (const orKey in subCondition) {
                        var trimmedKey = '';
                        if (orKey.startsWith('consignmentData.')) {
                            trimmedKey = orKey.replace('consignmentData.', '');
                        } else if (orKey.startsWith('piece.')) {
                            trimmedKey = orKey.replace('piece.', '');
                        } else if (orKey.startsWith('invoice.')) {
                            trimmedKey = orKey.replace('invoice.', '');
                        }
                        if (trimmedKey && mappedFields.includes(trimmedKey)) {
                            return true;
                        }
                    }
                }
                } else {
                    var trimmedKey = '';
                    if (key.startsWith('consignmentData.')) {
                        trimmedKey = key.replace('consignmentData.', '');
                    } else if (key.startsWith('piece.')) {
                        trimmedKey = key.replace('piece.', '');
                    } else if (key.startsWith('invoice.')) {
                        trimmedKey = key.replace('invoice.', '');
                    }
                    if (trimmedKey && mappedFields.includes(trimmedKey)) {
                        return true;
                    }
                }
            }
            return false;
        });
    }

    function validateDataUsingValidationBuilder(validateAllFields = false) {
        const formLayoutDataToValidate = [];
        if (validateAllFields) {
            formLayoutDataToValidate.push(...formLayout);
        } else {
            formLayoutDataToValidate.push(formLayout[currentTabIndex]);
        }
        const data = form.getFieldsValue();
        const piecesDetail = getPiecesDetail(data, piecesData, manufacturingCountryList);
        const invoicesDetail = getInvoicesDetail(data, invoicesData);
        const isPieceValidationsEnabled = checkForPieceField(formLayoutDataToValidate) || validateAllFields;
        const isInvoiceValidationsEnabled = checkForInvoiceField(formLayoutDataToValidate) || validateAllFields;
        if (isPieceValidationsEnabled) {
            const updatedFields = piecesDetail?.map((field: any) => {
                const updatedField: any = {};
                Object.keys(field)?.forEach((key): any => {
                    const mappedKey = validationBuilderKeysMapping[key];
                    updatedField[mappedKey || key] = field[key];
                });
                return updatedField;
            });
            data.piecesDetail = updatedFields;
        } else {
            data.piecesDetail = piecesDetail;
        }
        if (isInvoiceValidationsEnabled) {
            const updatedInvoices = invoicesDetail?.map((invoice: any) => {
                const updatedInvoice: any = {};
                Object.keys(invoice)?.forEach((key): any => {
                    const mappedKey = validationBuilderKeysMapping[key];
                    updatedInvoice[mappedKey || key] = invoice[key];
                });
                return updatedInvoice;
            });
            data.invoicesDetail = updatedInvoices;
        } else {
            data.invoicesDetail = invoicesDetail;
        }

        const filteredValidations = getFilteredValidations(validateAllFields);
        const formData = flattenObject(convertToAPIBodySaveSingle(data, { isCustomFieldAllowed: true, customFieldsList }));
        const dataFormatted: any = {
            consignmentData: {},
        };
        Object.keys(formData).forEach((key) => {
            if (validationBuilderKeysMapping[key]) {
                dataFormatted.consignmentData[validationBuilderKeysMapping[key]] = formData[key];
                if (formData[key] && intKeys.includes(validationBuilderKeysMapping[key])) {
                    dataFormatted.consignmentData[validationBuilderKeysMapping[key]] = +formData[key];
                }
            }
        });
        
        dataFormatted.consignmentData?.piecesDetail?.forEach((piece: any, index: number) => {
            Object.keys(piece).forEach((key) => {
                if (pieceLevelIntKeys.includes(key)) {
                    dataFormatted.consignmentData.piecesDetail[index][key] = piece[key] ? Number(piece[key]) : piece[key];
                }
            });
        });

        dataFormatted.consignmentData?.invoicesDetail?.forEach((invoice: any, index: number) => {
            Object.keys(invoice).forEach((key) => {
                if (invoiceLevelIntKeys.includes(key)) {
                    dataFormatted.consignmentData.invoicesDetail[index][key] = invoice[key] ? Number(invoice[key]) : invoice[key];
                }
            });
        });

        dataFormatted.consignmentData = unflattenObject(omitBy(dataFormatted.consignmentData, isEmptyValue));
        dataFormatted.piece = dataFormatted.consignmentData?.piecesDetail ? [ ...dataFormatted.consignmentData.piecesDetail ] : [];
        dataFormatted.piece = dataFormatted.consignmentData?.piecesDetail
            ? dataFormatted?.consignmentData?.piecesDetail?.map((piece: any) =>
                unflattenObject(omitBy(piece, isEmptyValue))
            )
            : [];
        dataFormatted.invoice = dataFormatted.consignmentData?.invoicesDetail
            ? dataFormatted?.consignmentData?.invoicesDetail?.map((invoice: any) =>
                unflattenObject(omitBy(invoice, isEmptyValue))
            )
            : [];
        let result = true;
        for (const data of filteredValidations) {
            let transformedWhenCondition = data?.filter?.when ?? {};
            transformedWhenCondition = referenceReplacer(transformedWhenCondition, dataFormatted);
            const siftedWhen = sift(transformedWhenCondition);
            if (siftedWhen(dataFormatted)) { //todo: add this condition to generic field
                let transformedWhatCondition = data?.filter?.what ?? {};
                transformedWhatCondition = referenceReplacer(transformedWhatCondition, dataFormatted);
                const sifted = sift(transformedWhatCondition);
                result = result && sifted(dataFormatted);
                if (!result) {
                    message.error(data.error);
                    break;
                }
            }

            if (Array.isArray(dataFormatted?.piece) && dataFormatted?.piece?.length) {
                const isMatchForEveryPiece = dataFormatted?.piece?.every((piece : any) => {
                    const pieceDataFormatted = { ...dataFormatted, piece };
                    let transformedPieceWhenCondition = data?.filter?.when ?? {};
                    transformedPieceWhenCondition = referenceReplacer(transformedPieceWhenCondition, pieceDataFormatted);
                    const siftedPieceWhen = sift(transformedPieceWhenCondition);
                    if (!siftedPieceWhen(pieceDataFormatted)) {
                        return true;
                    }
                    let transformedPieceWhatCondition = data?.filter?.what ?? {};
                    transformedPieceWhatCondition = referenceReplacer(transformedPieceWhatCondition, pieceDataFormatted);
                    const siftedPiece = sift(transformedPieceWhatCondition);
                    return siftedPiece(pieceDataFormatted);
                });
                result = result && isMatchForEveryPiece;
                if (!result) {
                    message.error(data.error);
                    break;
                }
            }

            if (Array.isArray(dataFormatted?.invoice) && dataFormatted?.invoice?.length) {
                const isMatchForEveryInvoice = dataFormatted?.invoice?.every((invoice : any) => {
                    const invoiceDataFormatted = { ...dataFormatted, invoice };
                    let transformedInvoiceWhenCondition = data?.filter?.when ?? {};
                    transformedInvoiceWhenCondition = referenceReplacer(transformedInvoiceWhenCondition, invoiceDataFormatted);
                    const siftedInvoiceWhen = sift(transformedInvoiceWhenCondition);
                    if (!siftedInvoiceWhen(invoiceDataFormatted)) {
                        return true;
                    }
                    let transformedInvoiceWhatCondition = data?.filter?.what ?? {};
                    transformedInvoiceWhatCondition = referenceReplacer(transformedInvoiceWhatCondition, invoiceDataFormatted);
                    const siftedInvoice = sift(transformedInvoiceWhatCondition);
                    return siftedInvoice(invoiceDataFormatted);
                });
                result = result && isMatchForEveryInvoice;
                if (!result) {
                    message.error(data.error);
                    break;
                }
            }
        }
        return result;
    }

    const checkCurrentPageErrors = async (addressTypeRadio?: string) => {
        setAddressErrors({});
        const errors: any = {};
        let hasAddressErrors = false;
        const fieldsToValidate = formLayout[currentTabIndex];
        const fields = fieldsToValidate?.sections?.map((section: any) => {
            const fieldsList = section?.fieldsList ?? [];
            return fieldsList.map((field: string) => {
                if (subLayout[field]) {
                    if (field === 'piece') {
                        const pieceFields = subLayout[field];
                        const arr: any = [];
                        pieceFields.forEach((pieceField: string) => {
                            if (pieceField === 'dangerousGood' || fieldNameToKeysMapping[pieceField]) {
                                const subKeys = pieceField === 'dangerousGood' ? subLayout['dangerous_good'] : fieldNameToKeysMapping[pieceField];
                                subKeys?.forEach((subKey: string) => {
                                    for (let i = 0; i < piecesData.length; i++) {
                                        arr.push(`${subKey}_${i}`);
                                    }
                                })
                            }
                            else {
                                for (let i = 0; i < piecesData.length; i++) {
                                    arr.push(`${pieceField}_${i}`);
                                }
                            }
                        });
                        return arr.flat();
                    }
                    if (field === 'invoice') {
                        const invoiceFields = subLayout[field];
                        const arr: any = [];
                        invoiceFields.forEach((invoiceField: string) => {
                            if (fieldNameToKeysMapping[invoiceField]) {
                                const subKeys = fieldNameToKeysMapping[invoiceField];
                                subKeys?.forEach((subKey: string) => {
                                    for (let i = 0; i < invoicesData.length; i++) {
                                        arr.push(`invoice_${subKey}_${i}`);
                                    }
                                });
                            } else {
                                for (let i = 0; i < invoicesData.length; i++) {
                                    arr.push(`invoice_${invoiceField}_${i}`);
                                }
                            }
                        });
                        return arr.flat();
                    }
                    return [...(subLayout[field] || [])];
                }
                return field in fieldNameToKeysMapping ? fieldNameToKeysMapping[field] : field;
            }).flat();
        }).flat() ?? [];
        if (fields.includes('address')) {
            if (addressTypeRadio) {
                fields.push(addressTypeRadio);
            } else {
                fields.push(...addressTypes);
            }
        }
        try {
            isProgrammaticValidationRef.current = true;
            try {
                await form.validateFields(fields);
            } finally {
                isProgrammaticValidationRef.current = false;
            }
        } catch (error: any) {
            error.errorFields?.forEach((err: any) => {
                const fieldName = err.name[0];
                if (fieldName?.includes('Address')) {
                    errors[`${fieldName}Main`] = err.errors[0];
                }
            });
            setAddressErrors(errors);
            return false;
        }
        for (const addressType of addressTypes) {
            if (fields.includes(addressType) || fields.includes('address')) {
                const formValues = form.getFieldsValue([addressType]);
                const address = formValues[addressType] ? flattenObject(formValues[addressType]) : {};
                for (const field of addressFields) {
                    try {
                        await validateData(`${addressType}.${field}`, address[field] || '');
                    } catch (error: any) {
                        const errorMessage = error?.message;
                        errors[addressType] = errors[addressType]
                            ? `${errors[addressType]}, ${errorMessage}`
                            : errorMessage;
                        hasAddressErrors = true;
                    }
                }
            }
        }
        if (hasAddressErrors) {
            setAddressErrors(errors);
            return false;
        }
        return true;
    };

    const handleTabChange = async (tabIndex: number) => {
        if (tabIndex === currentTabIndex || creatingAddress) {
            return;
        }
        const inlineErrorsCheck = await checkCurrentPageErrors();
        if(!inlineErrorsCheck){
            return;
        }
        if (currentTabIndex === formLayout.length - 1 || validateDataUsingValidationBuilder()) {
            setCurrentTabIndex(tabIndex);
        }
    };

    const handleSlotLockSuccess = () => {
        setIsSlotLocked(true);
        setFormSnapshot({ ...form.getFieldsValue() });
        setPreviousSlotData(null);
    };

    const handleFieldsChange = (changedFields: any, allFields: any) => {
        // Ignore changes emitted by programmatic validateFields() (submit / tab change),
        // they are not user edits and must not trigger the slot-refetch warning.
        if (isProgrammaticValidationRef.current) return;
        changedFields.forEach((field: any) => {
            if (field.name && field.name[0] === DeliveryDate.key) {
                if (isSlotSuggestionEnabled) {
                    if (field.value && moment(field.value).isValid()) {
                        setDeliveryDateValue(moment(field.value).format('YYYY-MM-DD'));
                    } else {
                        setDeliveryDateValue('');
                    }
                }
                setCurrentSlotData(null);
            }
        });

        if (!isSlotSuggestionEnabled) return;

        const hasWhitelistedChange = changedFields.some((field: any) => {
            const fieldName = field.name?.[0];
            const isWhitelistedPieceField = WHITELISTED_PIECE_FIELD_PREFIXES.some(prefix => fieldName?.startsWith(prefix));
            if (!WHITELISTED_CONSIGNMENT_FIELDS.includes(fieldName) && !isWhitelistedPieceField) {
                return false;
            }
            if (formSnapshot) {
                const isAddressField = ADDRESS_FIELDS.includes(fieldName);
                const fieldValue = isAddressField ? pickAddressComparableFields(field.value) : field.value;
                const snapshotValue = isAddressField ? pickAddressComparableFields(formSnapshot[fieldName]) : formSnapshot[fieldName];
                return !lodash.isEqual(fieldValue, snapshotValue);
            }
            return true;
        });

        if (isSlotLocked && !isWarningModalOpenRef.current && formSnapshot && hasWhitelistedChange) {
            const changedField = changedFields.find((field: any) => {
                const fieldName = field.name?.[0];
                const isWhitelistedPieceField = WHITELISTED_PIECE_FIELD_PREFIXES.some(prefix => fieldName?.startsWith(prefix));
                if (!WHITELISTED_CONSIGNMENT_FIELDS.includes(fieldName) && !isWhitelistedPieceField) return false;
                const isAddressField = ADDRESS_FIELDS.includes(fieldName);
                const fieldValue = isAddressField ? pickAddressComparableFields(field.value) : field.value;
                const snapshotValue = isAddressField ? pickAddressComparableFields(formSnapshot[fieldName]) : formSnapshot[fieldName];
                return !lodash.isEqual(fieldValue, snapshotValue);
            });
            if (!changedField) return;
            const fieldName = changedField.name[0];
            const previousValue = formSnapshot[fieldName];

            isWarningModalOpenRef.current = true;

            Modal.confirm({
                title: t('confirm_changes'),
                content: t('editing_fields_requires_slot_refetch'),
                okText: t('Yes'),
                cancelText: t('No'),
                onOk: () => {
                    setPreviousSlotData({
                        date:  currentSlotData?.deliveryDate,
                        slot: currentSlotData?.slot,
                        resourceSlotLockId: currentSlotData?.resourceSlotLockId,
                    });
                    setCurrentSlotData(null);

                    form.setFieldsValue({
                        [formFields.DeliveryTimeSlot.key]: undefined,
                        resourceSlotLockId: undefined,
                        deliveryDate: undefined,
                    });
                    setDeliveryDateValue('');
                    setIsSlotLocked(false);
                    isWarningModalOpenRef.current = false;
                },
                onCancel: () => {
                    form.setFieldsValue({
                        [fieldName]: previousValue,
                    });
                    if (fieldName === 'serviceType') {
                        setSelectedService(previousValue);
                    }
                    isWarningModalOpenRef.current = false;
                },
            });
        } else if (!isSlotLocked && hasWhitelistedChange) {
            form.setFieldsValue({
                [formFields.DeliveryTimeSlot.key]: undefined,
                resourceSlotLockId: undefined,
                deliveryDate: undefined,
            });
            setDeliveryDateValue('');
        }
    };

    // Adding/removing a piece mutates the form programmatically, so it bypasses the
    // onFieldsChange warning. Guard those actions with the same slot-refetch confirmation.
    const confirmSlotRefetchForPieceChange = (proceed: () => void) => {
        if (!isSlotSuggestionEnabled || !isSlotLocked || isWarningModalOpenRef.current) {
            proceed();
            return;
        }

        isWarningModalOpenRef.current = true;

        Modal.confirm({
            title: t('confirm_changes'),
            content: t('editing_fields_requires_slot_refetch'),
            okText: t('Yes'),
            cancelText: t('No'),
            onOk: () => {
                setPreviousSlotData({
                    date: currentSlotData?.deliveryDate,
                    slot: currentSlotData?.slot,
                    resourceSlotLockId: currentSlotData?.resourceSlotLockId,
                });
                setCurrentSlotData(null);

                form.setFieldsValue({
                    [formFields.DeliveryTimeSlot.key]: undefined,
                    resourceSlotLockId: undefined,
                    deliveryDate: undefined,
                });
                setDeliveryDateValue('');
                setIsSlotLocked(false);
                isWarningModalOpenRef.current = false;
                proceed();
            },
            onCancel: () => {
                isWarningModalOpenRef.current = false;
            },
        });
    };

    // Function to process all files and upload them to S3
    const processAndUploadFiles = async (documentDetails: any[]): Promise<DocumentDetailsUploadPayload[]> => {
        try {
            const newFileList: any = [];
            documentDetails?.forEach((data: any, index: number) => {
                let newFiles = data?.new_files_uploaded || [];
                const documentType = data?.document_type;
                newFiles = newFiles?.map((newFile: any) => {
                    return {
                        ...(newFile || {}),
                        document_type: documentType,
                        index,
                    };
                });
                newFileList?.push(...(newFiles || []));
            });

            
            const promises = newFileList?.map(async (file: any) => {
                const bodyGetUrl = {
                    content_type: file?.type,
                };

                const response = await getUploadFileUrls(bodyGetUrl);
                const upload = await uploadImageToS3(
                    new Blob([file?.originFileObj as BlobPart], {
                        type: file?.type,
                    }),
                    response?.data?.result?.imageSignedUrl,
                    file?.type,
                );
                const s3UrlToReturn = upload?.isSuccess ? response?.data?.result?.imageUrl : null;
                return {
                    url: s3UrlToReturn,
                    document_type: file?.document_type,
                    index: file?.index,
                    isSuccess: !!upload?.isSuccess,
                };
            });

            const fileUrls = await Promise.all(promises);
            const anyFailed = fileUrls?.some((file) => !file?.isSuccess);
            if (anyFailed) {
                return [];
            }
            const newlyUploaded = fileUrls?.filter((file: any) => !!file.url);
            const newlyUploadedFiles = groupBy(newlyUploaded, 'index');

            // Generating api payload for each document type
            const documentDetailsToUpload: DocumentDetailsUploadPayload[] = [];

            documentDetails?.forEach((data: any, index: number) => {
                const documentType = data?.document_type;
                if (documentType) {
                    const newFileObjects = newlyUploadedFiles[index] || [];
                    newFileObjects?.forEach((file) => {
                        documentDetailsToUpload?.push({
                            type: documentType,
                            url: file?.url,
                        });
                    });
                }
            });
            
            return documentDetailsToUpload;
        } catch (error) {
            return [];
        }
    };

    async function checkForErrors() {
        try {
            isProgrammaticValidationRef.current = true;
            let formValues;
            try {
                formValues = await form.validateFields();
            } finally {
                isProgrammaticValidationRef.current = false;
            }
            const data = form.getFieldsValue();
            const piecesDetail = getPiecesDetail(data, piecesData, manufacturingCountryList);
            const invoicesDetail = getInvoicesDetail(data, invoicesData);
            const updatedData = {
                ...formValues,
            };
            let isPoValid = true;
            if (isPieceEnabled) {
                updatedData.piecesDetail = piecesDetail;
                piecesDetail.forEach((piece: any, index: number) => {
                    if (validatePiecePurchaseOrder && piece.purchase_order_number && !form.getFieldValue(`valid_purchaseOrderNumber_${index}`)) {
                        message.error('Please validate Purchase Order Number');
                        isPoValid = false;
                        return;
                    }
                });
            }
            if (!isPoValid) {
                return;
            }
            if (isPieceEnabled) {
                updatedData.numberOfPieces = piecesDetail?.length;
            }
            if (isInvoiceEnabled) {
                updatedData.invoicesDetail = invoicesDetail;
            }
            if (validateDataUsingValidationBuilder(true)) {
                setCreating(true);
                
                // Check if there are any files to upload
                const documentUploadField = form.getFieldValue('documentDetails');
                let documentDetailsToUpload: DocumentDetailsUploadPayload[] = [];
                
                if (Array.isArray(documentUploadField) && documentUploadField.length > 0) {
                    // Process and upload files if there are any
                    documentDetailsToUpload = await processAndUploadFiles(documentUploadField);
                    
                    // Update the form data with the S3 URLs
                    if (documentDetailsToUpload?.length > 0) {
                        updatedData.documentDetails = documentDetailsToUpload;
                    }

                    if (!documentDetailsToUpload?.length) {
                        message.error('Failed to upload documents. Remove the attached documents or try again later.');
                        setCreating(false);
                        return;
                    }
                }

                if (isInvoiceEnabled && invoicesDetail?.length > 0) {
                    const invoiceProofResults = await Promise.all(
                        invoicesDetail.map(async (invoice: any, index: number) => {
                            const proofImageList = form.getFieldValue(`invoice_${ProofImageList.key}_${index}`);
                        
                            try {
                                return await uploadImagesToS3(proofImageList);
                            } catch (error: any) {
                                throw new Error(`${error?.message} - Upload failed for Invoice ${index + 1}`);
                            }
                        })
                    );
                    
                    updatedData.invoicesDetail = invoicesDetail.map((invoice: any, index: number) => ({
                        ...invoice,
                        [ProofImageList.key]: invoiceProofResults[index]?.length ? invoiceProofResults[index] : undefined,
                    }));
                }

                updatedData.invoicesDetail = updatedData.invoicesDetail?.filter((invoice: any) => {
                    return Object?.values(invoice)?.some((value: any) => 
                        value !== undefined && value !== null && value !== '' && 
                        !(Array.isArray(value) && value.length === 0)
                    );
                });

                if (editData?.reference_number && !updatedData.referenceNumber) {
                    updatedData.referenceNumber = editData.reference_number;
                }

                let response;
                if (softdataCreationUnifiedFlow) {
                    const apiBody = transformPayloadNew(updatedData, {
                        showRiskSurchargeType,
                        isCustomFieldAllowed: true,
                        customFieldsList,
                        isCodFieldPresent,
                        isCustomForm: true,
                        allowChildLoginOnParent,
                        source: editData ? 'CUSTOMER_PORTAL_SINGLE_UPDATE_V2' : 'CUSTOMER_PORTAL_SINGLE_V2',
                        currentSlotData,
                        previousSlotData,
                    });
                    response = editData ? await editSingleCnWithPx(apiBody) : await createSingleCnWithPx(apiBody);
                } else {
                    const apiBody = convertToAPIBodySaveSingle(updatedData, {
                        editData,
                        showRiskSurchargeType,
                        isCustomFieldAllowed: true,
                        customFieldsList,
                        isCodFieldPresent,
                        source: 'CUSTOMER_PORTAL_SINGLE_V2',
                    });
                    response = await createConsignment(apiBody);
                }
                if (response.isSuccess) {
                    loadconsignments();
                    setSuccess({
                        ...(response?.data || []),
                        showInvoicePrint: showInvoiceOptions
                            && updatedData.consignmentCategory === 'international'
                            && updatedData.courierType === 'non-document',
                    });
                } else {
                    if (response.errorReason === 'SLOT_LOCK_EXPIRED') {
                        setCurrentSlotData(null);
                        setIsSlotLocked(false);
                        setDeliveryDateValue('');
                        form.setFieldsValue({
                            [formFields.DeliveryTimeSlot.key]: undefined,
                            resourceSlotLockId: undefined,
                            deliveryDate: undefined,
                        });
                    }
                    message.error(response.errorMessage);
                }
                setCreating(false);
            }
        } catch (e: any) {
            const firstError = e?.errorFields?.[0]?.errors?.[0];
            message.error(firstError || 'Some fields are incomplete / invalid');
            setCreating(false);
        }
    }

    async function handleAction(action: ButtonAction) {
        switch (action) {
            case ButtonAction.PREV: return setCurrentTabIndex(currentTabIndex - 1);
            case ButtonAction.NEXT:
                const inlineErrorsCheck = await checkCurrentPageErrors();
                if (!inlineErrorsCheck) {
                    return;
                }
                if (validateDataUsingValidationBuilder()) {
                    return setCurrentTabIndex(currentTabIndex + 1);
                }
                return null;
            case ButtonAction.SUBMIT: return checkForErrors();
            default: return null;
        }
    }

    const renderSubmitButton = () => {
        return (
            <Button
                type="primary"
                disabled={creatingAddress}
                onClick={() => handleAction(ButtonAction.SUBMIT)}
                loading={creating}
                className={classes.nextButton}
            >
                {t(ButtonNames.SUBMIT)}
            </Button>
        );
    };

    const renderLeftButton = () => {
        if (currentTabIndex > 0) {
            return (
                <Button
                    onClick={() => handleAction(ButtonAction.PREV)}
                    disabled={creatingAddress}
                    className={classes.prevButton}
                >
                    <LeftOutlined /> {t('Previous')}
                </Button>
            );
        }
    };

    const renderRightButton = () => {
        if (currentTabIndex < (formLayout?.length) - 1) {
            return (
                <Button
                    type="primary"
                    onClick={() => handleAction(ButtonAction.NEXT)}
                    loading={creating}
                    disabled={creatingAddress}
                    className={classes.nextButton}
                >
                    {t('Next')}
                    {<RightOutlined />}
                </Button>
            );
        }
        else {
            return renderSubmitButton();
        }
    };

    const renderFooter = () => {
        return (
            <div className={classes.footer}>
                <div style={{
                    display: 'flex',
                    flex: 1,
                    gap: 12,
                    justifyContent: currentTabIndex > 0 ? 'space-between' : 'end',
                }}
                >
                    {renderLeftButton()}
                    {renderRightButton()}
                </div>
            </div>
        );
    };

    const renderCloseConfirmModal = () => {
        return (
            <Modal
                title={(
                    <div style={{ fontWeight: 600 }}>
                        <ExclamationCircleFilled style={{ color: '#EA2626', fontSize: 16 }} />
                        &nbsp;
                        {t('Confirm Action')}
                    </div>
                )}
                visible={closeConfirm}
                onCancel={() => setCloseConfirm(false)}
                footer={[
                    <Button key="back" type="text" onClick={() => setCloseConfirm(false)}>
                        {t('No, Continue')}
                    </Button>,
                    <Button key="submit" type="primary" onClick={onClose}>
                        {t('Yes, Cancel')}
                    </Button>,
                ]}
            >
                { i18n.exists('exit_cn_create_form')
                    ? t('exit_cn_create_form')
                    : ('Exiting will result in unsaved changes to your consignment creation.'
                    + ' Do you want to cancel adding consignment now?')}
            </Modal>
        );
    };

    const renderHeader = () => {
        return (
            <div className={classes.header}>
                <div className={classes.flexRow}>
                    <Cross onClick={() => setCloseConfirm(true)} alt="close" className={classes.closeIcon} />
                    <span>{editData ? 'Edit Consignment' : t('add_consignment')}</span>
                    {editData?.reference_number && (
                        <span className={classes.headerReferenceNumber}>{editData.reference_number}</span>
                    )}
                </div>
            </div>
        );
    };

    const isRequired = (isPiece: any, key: string) => {
        const isFTL = actionType === CreateActions.FTLHyperlocal;
        let required = false;
        if (isPiece) {
            required = required || mandatoryPieceDetails[key];
        } else {
            if (consignmentCategory === 'international') {
                required = [
                    formFields.Weight.key,
                    formFields.DeclaredValue.key,
                    formFields.CustomerReference.key,
                ].includes(key);
            }
            if (consignmentCategory === 'international' && itemType === 'non-document') {
                required = required || mandatoryFieldNonDocIntl[key];
            }
            if (consignmentCategory === 'international' && form.getFieldValue('shipmentPurpose') === 'COMMERCIAL') {
                required = required || mandatoryFieldShipmentCommercial[key];
            }
        }
        if (isFTL) {
            required = [
                formFields.MovementType.key,
                formFields.VehicleCategory.key,
            ].includes(key);
        }
        return required;
    };

    const getSummarySections = () => {
        const sections: any[] = [];
        formLayoutConfig?.forEach((pageData: any, index: number) => {
            pageData?.sections?.forEach((section: any) => {
                if (section.prettyName === SECTION_NAMES.SCHEDULE_DETAILS && !pickup_schedule_creation) {
                    return;
                }
                sections.push({
                    ...section,
                    fieldsList: section.fieldsList.filter((field: string) => {
                        if ((!ifFieldExistsInMapping(field, enableServiceability) ) && (!customFieldsList?.some((customField: any) => customField?.id === field))) {
                            return false;
                        } else if (customFormSummaryStepNecessaryFields.includes(field)) {
                            return true;
                        } else if (consignmentCategory === 'domestic' && internationalFields.includes(field)) {
                            return false;
                        } else if (courierType === 'non-document' && nonDocumentFields.includes(field)) {
                            return false;
                        } else {
                            return true;
                        }
                    }),
                    goTo: index,
                });
            });
        });
        return sections;
    };

    const getFieldValidations = (key: any, isPieceLevel = false) => {
        const relationKeys = ['$eq', '$ne', '$gt', '$gte', '$lt', '$lte'];
        const filteredValidations = getFilteredValidations(true);
        const mappedKey = validationBuilderKeysMapping[key];
        const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
        if (mappedKey) {
            return filteredValidations.filter((val: any) => {
                const condition = val?.filter?.what || {};
                const when = val?.filter?.when || {};
                if (Object.keys(when).length === 0) {
                    for (const key in condition) {
                        if (key === '$or' || key === '$and') {
                            for (const subCondition of condition[key]) {
                                if (Object.keys(subCondition).some(sub => sub !== `${sourceKey}.${mappedKey}`)) {
                                    return false;
                                }
                                for(const con of Object.values(subCondition)) {
                                    for (const relation of relationKeys) {
                                        if ((con as any)?.[relation]?.$reference) {
                                            return false;
                                        }
                                    }
                                }
                            }
                            return true;
                        } else if (key === `${sourceKey}.${mappedKey}`) {
                            for (const relation of relationKeys) {
                                if (condition[key]?.[relation]?.$reference) {
                                    return false;
                                }
                            }
                            return true;
                        }
                    }
                }
                return false;
            });
        }
    }

    const isNinCondition = (condition: any) => {
        return condition?.$nin && Array.isArray(condition.$nin) &&
            condition.$nin.length === 4 &&
            condition.$nin.includes(null) &&
            condition.$nin.includes("") &&
            condition.$nin.includes(0);
    };

    const getIsRequiredValidation = (key: string, isPieceLevel = false) => {
        const mappedKey = validationBuilderKeysMapping[key];
        const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
        if (mappedKey) {
            const validation = getFieldValidations(key, isPieceLevel);
            for (const data of validation) {
                let transformedWhatCondition = data?.filter?.what ?? {};
                const condition = transformedWhatCondition[`${sourceKey}.${mappedKey}`] || {};
                if (isNinCondition(condition)) {
                    return true;
                };
            }
        }
        return false;
    };

    const validateData = async (key: string, value: string, isPieceLevel = false) => {
        const mappedKey = validationBuilderKeysMapping[key];
        if (mappedKey) {
            const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
            const validation = getFieldValidations(key, isPieceLevel);
            let cnData: any = {
                [sourceKey]: {
                    [mappedKey]: value,
                }
            };
            if ((isPieceLevel && pieceLevelIntKeys.includes(mappedKey))
                || (!isPieceLevel && intKeys.includes(mappedKey))) {
                cnData[sourceKey][mappedKey] = value ? +value : undefined;
            }
            cnData = unflattenObject(flattenObject(cnData));
            for (const data of validation) {
                let transformedWhatCondition = data?.filter?.what ?? {};
                transformedWhatCondition = referenceReplacer(transformedWhatCondition, cnData);
                const sifted = sift(transformedWhatCondition);
                if (!sifted(cnData)) {
                    return Promise.reject(new Error(data.error));
                }
            }
        }
        return Promise.resolve();
    };

    const getValidationRules = (fieldData: any, isPieceLevel = false, props: any = {}) => {
        const formRuleRequired = {
            ...formRules.required,
            message: i18n.exists('required') ? t('required') : 'Required',
        };
        const rulesList: any[] = [];
        if (isRequired(isPieceLevel, fieldData.key)) {
            rulesList.push(formRuleRequired);
        }
        if (props.MAX_LIMIT === 100 && fieldData.inputType === 'number') {
            rulesList.push(formRules.maxNumber100);
        }
        if (props.MAX_LIMIT === 1000 && fieldData.inputType === 'number') {
            rulesList.push(formRules.maxNumber1000);
        }
        rulesList.push({
            validator: async (_: any, value: any) => {
                return await validateData(fieldData.key, value, isPieceLevel);
            },
        });
        return rulesList;
    };

    const renderPage = (pageData: any, pageIndex: number) => {
        if(pageData.prettyName === 'summary' && currentTabIndex === pageIndex) {
            const data = form.getFieldsValue();
            const piecesDetail = getPiecesDetail(data, piecesData, manufacturingCountryList);
            const invoicesDetail = getInvoicesDetail(data, invoicesData);
            if (isPieceEnabled) {
                data.piecesDetail = piecesDetail;
            }
            if (isInvoiceEnabled) {
                data.invoicesDetail = invoicesDetail;
            }
            const formData = flattenObject(convertToAPIBodySaveSingle(data, { isCustomFieldAllowed: true, customFieldsList, currentSlotData }));
            formData.isCOD = data.isCOD;
            formData.childClient = data.childClient;
            formData.manufacturingCountryName = manufacturingCountryList.find((country: any) => country.value === data.manufacturingCountry)?.label;
            return (
                <SummaryStep
                    formData={formData}
                    sections={getSummarySections()}
                    handleTabChange={handleTabChange}
                    customFieldsList={customFieldsList}
                />
            );
        }
        if (pageData) {
            const { sections = [] } = pageData;
            return (
                <div style={{ display: currentTabIndex === pageIndex ? 'block' : 'none' }}>
                    {sections.map((section: any, sectionIndex: number) => {
                          if (section.prettyName === SECTION_NAMES.SCHEDULE_DETAILS && !pickup_schedule_creation) {
                            return null;
                        }
                        const { fieldsList = [] } = section;
                        return (
                            <>
                                <div className={isMobile ? classes.boxMobile : classes.box}>
                                    <div className={isMobile ? classes.boxTitleMobile : classes.boxTitle}>
                                        <span>{section.prettyName}</span>
                                    </div>
                                    {isMobile && <Divider style={{ margin: isMobile ? '8px 0' : '0px' }} />}
                                    <div className={classes.boxFieldsCol}>
                                        <Row gutter={isMobile ? 10 : 20}>
                                            {fieldsList.map((fieldId: string) => getFormFieldFromMapping(fieldId, form, {
                                                childClients,
                                                piecesData,
                                                setPiecesData,
                                                invoicesData,
                                                setInvoicesData,
                                                pudoHubs,
                                                categoryList,
                                                contentList,
                                                itemUnits,
                                                currencyList,
                                                countryList,
                                                incotermsList,
                                                isRequired,
                                                shipmentPurposeList,
                                                softdataActionTypeEnum,
                                                loadTypeList: loadType,
                                                isCurrentTab: currentTabIndex === pageIndex,
                                                isFTL: actionType === CreateActions.FTLHyperlocal,
                                                currentCustomField: customFieldsList.filter((field: any) => field.id === fieldId),
                                                customFieldsList,
                                                key: fieldId,
                                                isPieceEnabled,
                                                placeholderNumPieces,
                                                isDisabledNumPiece,
                                                manufacturingCountryList,
                                                fetchPoDetails,
                                                productCodeLists,
                                                resetProductCode,
                                                showProductCodeDropdown: show_product_code_dropdown,
                                                productHsCodeMapping,
                                                getValidationRules,
                                                getIsRequiredValidation,
                                                showDeclaredCurrencyField: fieldsList.find((field: string) => field === 'declaredCurrency'),
                                                addressErrors,
                                                checkErrorOnAddressChange: checkCurrentPageErrors,
                                                productCodeActive,
                                                disabledFields,
                                                setDisabledFields,
                                                productCode,
                                                setProductCode,
                                                destinationHolidays,
                                                setDestinationHolidays,
                                                destinationDeliveryDays,
                                                setDestinationDeliveryDays,
                                                selectedService,
                                                setSelectedService,
                                                isCodFieldPresent,
                                                editData,
                                                onSlotLockSuccess: handleSlotLockSuccess,
                                                previousSlotData,
                                                isSlotLocked,
                                                deliveryDateValue,
                                                currentSlotData,
                                                setCurrentSlotData,
                                                destinationHubTimezone,
                                                useHubTimezoneForStorage,
                                                subLayout,
                                                confirmSlotRefetchForPieceChange,
                                                isProgrammaticValidationRef,
                                                showRiskSurchargeType,
                                                allowChildLoginOnParent,
                                            },enableServiceability, setCreatingAddress))}
                                        </Row>
                                    </div>
                                </div>
                                {
                                    sectionIndex < sections.length - 1 ? (
                                        <div
                                            style={{
                                                height: 1,
                                                margin: isMobile ? '12px 0px' : '0px',
                                                width: '100%',
                                                backgroundColor: '#EDEDED',
                                            }}
                                        />
                                    ) : <></>
                                }
                            </>
                        );
                    })}
                </div>
            );
        }
        return <></>;
    };

    const renderPages = () => {
        const pages = [...(formLayout || [])];
        return pages.map(renderPage);
    };


    const renderCreationStepper = () => {
        const steps = formLayout.filter((step: any, index: number) => index < formLayout.length);

        return (
            <div className={isMobile ? classes.creationStepperMobile : classes.creationStepper}>
                <Steps
                    current={currentTabIndex}
                    onChange={handleTabChange}
                    size={isMobile ? 'small' : 'default'}
                    direction="horizontal"
                    labelPlacement="vertical"
                    responsive={false}
                    items={steps.map((step: any, index: number) => ({
                        title: !isMobile ? t(step?.prettyName || '') : '',
                        status: visited[index] && index !== currentTabIndex ? 'finish' : index === currentTabIndex ? 'process' : 'wait',
                    }))}
                />
                {isMobile && (
                    <div className={classes.stepNameMobile}>
                        {t(formLayout[currentTabIndex]?.prettyName || '')}
                        <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                            Step {currentTabIndex + 1} of {formLayout.length}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Drawer
            visible={visible}
            width={isMobile ? "100%" : "80%"}
            placement="right"
            title={renderHeader()}
            footer={renderFooter()}
            onClose={() => setCloseConfirm(true)}
            className={classes.main}
            closable={false}
            footerStyle={{
                padding: 0,
                margin: 0,
            }}
        >
            { loading ? <Loader /> : <></> }
            <Form form={form} className={classes.form} onFieldsChange={handleFieldsChange}>
                {renderCreationStepper()}
                <div className={classes.formContent}>
                    {renderPages()}
                </div>
                {renderCloseConfirmModal()}
            </Form>
        </Drawer>
    );
};
const mapStateToProps = (state: ReduxStore) => {
    const { master } = state;
    const { config, Customer, properties } = master;
    const customerPortalConfig: any = config?.customer_portal_config;
    const allowChildLoginOnParent = master?.parts_to_show?.allow_child_login_on_parent || false;
    const softdataCreationUnifiedFlow = master?.parts_to_show?.softdata_creation_unified_flow_enabled;
    const softdataActionTypeEnum = config?.softdata_action_type_enum;
    const shipmentPurposeList: any = config?.shipment_purpose_list;
    const mandatoryFieldNonDocIntl = customerPortalConfig?.mandatory_field_non_document_international || {};
    const mandatoryFieldShipmentCommercial = customerPortalConfig?.mandatory_shipment_commercial || {};
    const mandatoryPieceDetails = customerPortalConfig?.mandatory_piece_details || {};
    const showRiskSurchargeType = customerPortalConfig?.show_risk_surcharge_type;
    const showInvoiceOptions = Customer?.show_invoice_options;
    const useCategory = config?.use_category_in_commodity_data;
    const formLayoutConfig = config?.customer_portal_order_creation_config?.form_layout || [];
    const subLayout = config?.customer_portal_order_creation_config?.sub_layout || {};
    const customFieldsList = config?.custom_fields_list_for_form || [];
    const pickup_schedule_creation = properties?.pickup_schedule_creation;
    const show_product_code_dropdown = properties?.show_product_code_dropdown;
    const validatePiecePurchaseOrder = master.config?.validate_piece_purchase_order_number || false;
    const useHubTimezoneForStorage = config?.timezone_handling?.use_hub_timezone_for_storage || false;
    const fieldsToDisableInEdit = Array.isArray(config?.customer_portal_order_creation_config?.disabled_edit_consignment_fields)
        ? config.customer_portal_order_creation_config.disabled_edit_consignment_fields
        : [];
    const disableSlotSuggestion = properties?.disable_slot_suggestion || false;
    return {
        mandatoryFieldNonDocIntl,
        mandatoryFieldShipmentCommercial,
        mandatoryPieceDetails,
        showRiskSurchargeType,
        showInvoiceOptions,
        useCategory,
        formLayoutConfig,
        shipmentPurposeList,
        subLayout,
        customFieldsList,
        pickup_schedule_creation,
        show_product_code_dropdown,
        allowChildLoginOnParent,
        softdataCreationUnifiedFlow,
        softdataActionTypeEnum,
        autoCalculateDetails: customerPortalConfig?.auto_calculate_single_cn_fields_international,
        enableServiceability: customerPortalConfig?.enable_serviceability,
        validatePiecePurchaseOrder,
        useHubTimezoneForStorage,
        fieldsToDisableInEdit,
        disableSlotSuggestion,
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectRouter: true,
    connectTranslession: true,
};


export default withStyles(singleConsignmentStyles)(GenericHoc(hocConfig)(SingleConsignment));
